import { FETCHDERICTORY } from "../types";


export const derictory = (state = {}, action) => {
  switch(action.type){
    case FETCHDERICTORY:
      return action.derictory
    default:
      return state
  }
}